import { render, staticRenderFns } from "./PageSet.vue?vue&type=template&id=02bddd01&scoped=true&"
import script from "./PageSet.vue?vue&type=script&lang=js&"
export * from "./PageSet.vue?vue&type=script&lang=js&"
import style0 from "./PageSet.vue?vue&type=style&index=0&id=02bddd01&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bddd01",
  null
  
)

export default component.exports